<template>
    <div>
        <b-modal
            id="privacy-policy-popup"
            title="Privacy Policy"
            size="lg"
            hide-footer
            no-close-on-backdrop
        >
            <div id="style-3" class="scrollable">
                <div class="WordSection1">
                    <p class="HeadingLevel2">
                        <span lang="EN-GB">IDENFO PRIVACY POLICY</span>
                    </p>

                    <p class="HeadingLevel2">
                        <span lang="EN-GB">&nbsp;</span>
                    </p>

                    <p class="HeadingLevel2">
                        <span lang="EN-GB">CONTENTS</span>
                    </p>

                    <p class="HeadingLevel2">
                        <span lang="EN-GB"
                            >____________________________________________________________</span
                        >
                    </p>

                    <p class="HeadingLevel2">
                        <span lang="EN-GB">CLAUSE</span>
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000000"
                                ><i>1.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >Important information and who we
                                    are....................................................................................................... </i
                                ><i>1</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000001"
                                ><i>2.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >The data we collect about
                                    you.................................................................................................................... </i
                                ><i>3</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000002"
                                ><i>3.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >How is your personal data
                                    collected?........................................................................................................ </i
                                ><i>4</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000003"
                                ><i>4.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >How we use your personal
                                    data................................................................................................................. </i
                                ><i>5</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000004"
                                ><i>5.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >Disclosures of your personal
                                    data.............................................................................................................. </i
                                ><i>8</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000005"
                                ><i>6.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >International
                                    transfers................................................................................................................................. </i
                                ><i>9</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000006"
                                ><i>7.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >Data
                                    security............................................................................................................................................. </i
                                ><i>10</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000007"
                                ><i>8.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >Data
                                    retention........................................................................................................................................... </i
                                ><i>10</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000008"
                                ><i>9.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >      </span
                                    >Your legal
                                    rights........................................................................................................................................ </i
                                ><i>10</i></a
                            ></span
                        >
                    </p>

                    <p class="MsoToc1">
                        <span lang="EN-GB"
                            ><a href="#_Toc256000009"
                                ><i>10.</i
                                ><i
                                    ><span
                                        style="
                                            font-family: 'Calibri', sans-serif;
                                        "
                                        >        </span
                                    >Glossary................................................................................................................................................ </i
                                ><i>12</i></a
                            ></span
                        >
                    </p>

                    <p class="HeadingLevel2">
                        <span lang="EN-GB">&nbsp;</span>
                    </p>
                </div>

                <b
                    ><span
                        lang="EN-GB"
                        style="
                            font-size: 14pt;
                            font-family: 'Arial', sans-serif;
                            color: black;
                        "
                        ><br
                            clear="all"
                            style="page-break-before: always"
                        /> </span
                ></b>

                <div class="WordSection2">
                    <p class="HeadingLevel2">
                        <span lang="EN-GB">&nbsp;</span>
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a787974"
                            ><span lang="EN-GB">Introduction</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a496830"
                            ><span lang="EN-GB"
                                >Welcome to Idenfo Limited's privacy policy.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a410588"
                            ><span lang="EN-GB"
                                >We respect your privacy and are committed to
                                protecting your personal data. This privacy
                                policy will inform you as to how we look after
                                your personal data when you visit and use our
                                website (regardless of where you visit it from)
                                and tell you about your privacy rights and how
                                the law protects you.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a183820"
                            ><span lang="EN-GB"
                                >This privacy policy is provided in a layered
                                format so you can click through to the specific
                                areas set out below. Please also use the
                                Glossary to understand the meaning of some of
                                the terms used in this privacy policy.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a345171"
                            ><b
                                ><span lang="EN-GB"
                                    >1.
                                    <i
                                        >IMPORTANT INFORMATION AND WHO WE ARE</i
                                    ></span
                                ></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a313821"
                            ><b
                                ><span lang="EN-GB"
                                    >2.
                                    <i>THE DATA WE COLLECT ABOUT YOU</i></span
                                ></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a575864"
                            ><b
                                ><span lang="EN-GB"
                                    >3.
                                    <i>HOW IS YOUR PERSONAL DATA COLLECTED?</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a919982"
                            ><b
                                ><span lang="EN-GB"
                                    >4. <i>HOW WE USE YOUR PERSONAL DATA</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a469725"
                            ><b
                                ><span lang="EN-GB"
                                    >5.
                                    <i
                                        >DISCLOSURES OF YOUR PERSONAL DATA</i
                                    ></span
                                ></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a798662"
                            ><b
                                ><span lang="EN-GB"
                                    >6. <i>INTERNATIONAL TRANSFERS</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a496559"
                            ><b
                                ><span lang="EN-GB"
                                    >7. <i>DATA SECURITY</i></span
                                ></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a915856"
                            ><b
                                ><span lang="EN-GB"
                                    >8. <i>DATA RETENTION</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a700940"
                            ><b
                                ><span lang="EN-GB"
                                    >9. <i>YOUR LEGAL RIGHTS</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a292340"
                            ><b
                                ><span lang="EN-GB"
                                    >10. <i>GLOSSARY</i>
                                </span></b
                            ></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >1.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a819128"></a
                            ><a name="_Toc256000000"
                                >Important information and who we are</a
                            ></span
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a424696">Purpose of this privacy policy</a>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a644190"
                            ><span lang="EN-GB"
                                >This privacy policy aims to give you
                                information on how we collect and processes your
                                personal data through your use of this website,
                                including any data you may provide through this
                                website when you sign up to use our services.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a961414"
                            ><span lang="EN-GB"
                                >This website is not intended for children and
                                we do not knowingly collect data relating to
                                children.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a222632"
                            ><span lang="EN-GB"
                                >It is important that you read this privacy
                                policy together with any other privacy policy or
                                fair processing policy we may provide on
                                specific occasions when we are collecting or
                                processing personal data about you so that you
                                are fully aware of how and why we are using your
                                data. This privacy policy supplements other
                                notices and privacy policies and is not intended
                                to override them.
                            </span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a985786"
                            ><span lang="EN-GB">Controller</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a382234"
                            ><span lang="EN-GB"
                                >Idenfo Limited is the controller and
                                responsible for your personal data (collectively
                                referred to as &quot;Idenfo&quot;,
                                &quot;we&quot;, &quot;us&quot; or
                                &quot;our&quot; in this privacy policy).</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a676010"
                            ><span lang="EN-GB"
                                > Idenfo is made up of different legal entities.
                                Idenfo Limited is based in the United Kingdom
                                and owns subsidiary companies in UAE (Idenfo
                                Solutions Pvt Ltd), Pakistan (Idenfo Pakistan
                                Pvt Ltd) and Malaysia (Idenfo Malaysia Sdn.
                                Bhd). Additional subsidiaries may be created by
                                Idenfo in the future. This privacy policy is
                                issued on behalf of all the companies in the
                                Idenfo Group so when we mention
                                “Idenfo”,&quot;we&quot;, &quot;us&quot; or
                                &quot;our&quot; in this privacy policy, we are
                                referring to all the companies in the Group
                                responsible for processing your data. Idenfo
                                Limited is the controller and responsible for
                                this website.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a540866"
                            ><span lang="EN-GB"
                                >We have appointed a data protection officer
                                (DPO) who is responsible for overseeing
                                questions in relation to this privacy policy. If
                                you have any questions about this privacy
                                policy, including any requests to exercise
                                <i>your legal rights</i>, please contact the DPO
                                using the details set out below.
                            </span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a599551"
                            ><span lang="EN-GB">Contact details</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a501999"
                            ><span lang="EN-GB"
                                >If you have any questions or complaints about
                                this privacy policy or our privacy practices,
                                please contact our DPO in the following ways in
                                order to enable us to investigate the matter
                                concerned further:</span
                            ></a
                        ><a name="a992335"></a>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <span lang="EN-GB">Full name of legal entity: </span
                        ><b><span lang="EN-GB">Idenfo Limited</span></b>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a770336"
                            ><span lang="EN-GB">Email address:</span></a
                        ><span lang="EN-GB"> info@idenfo.com</span>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a432477"
                            ><span lang="EN-GB">Postal address:</span></a
                        ><span lang="EN-GB">
                            Bankside 300 Peachman Way, Broadland Business Park,
                            Norwich, Norfolk, United Kingdom, NR7 0LB<a
                                name="a389597"
                                >. You have the right to make a complaint at any
                                time to the Information Commissioner's Office
                                (ICO), the UK regulator for data protection
                                issues (</a
                            ></span
                        ><span class="MsoHyperlink"
                            ><span
                                lang="EN-GB"
                                style="
                                    font-style: normal;
                                    text-decoration: none;
                                "
                                >www.ico.org.uk</span
                            ></span
                        ><span lang="EN-GB"
                            >). We would, however, appreciate the chance to deal
                            with your concerns before you approach the ICO so
                            please contact us in the first instance.
                        </span>
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a465678"
                            ><span lang="EN-GB"
                                >Changes to the privacy policy and your duty to
                                inform us of changes</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a292073"
                            ><span lang="EN-GB"
                                >We keep our privacy policy under regular
                                review. This version was last updated in August
                                2021. Historic versions can be obtained by
                                contacting us
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a457168"
                            ><span lang="EN-GB"
                                >It is important that the personal data we hold
                                about you is accurate and current. Please keep
                                us informed if your personal data changes during
                                your relationship with us.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a378536"><span lang="EN-GB">&nbsp;</span></a>
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <span lang="EN-GB">Third-party links</span>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a998713"
                            ><span lang="EN-GB"
                                >This website may include links to third-party
                                websites, plug-ins and applications. Clicking on
                                those links or enabling those connections may
                                allow third parties to collect or share data
                                about you. We do not control these third-party
                                websites and are not responsible for their
                                privacy statements. When you leave our website,
                                we encourage you to read the privacy policy of
                                every website you visit.</span
                            ></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >2.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a480831"></a
                            ><a name="_Toc256000001"
                                >The data we collect about you</a
                            ></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a738838"
                            ><span lang="EN-GB"
                                >Personal data, or personal information, means
                                any information about an individual from which
                                that person can be identified. It does not
                                include data where the identity has been removed
                                (anonymous data).</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a562087"
                            ><span lang="EN-GB"
                                >We <b>may</b> collect, use, store and transfer
                                different kinds of personal data about you which
                                we have grouped together as follows:</span
                            ></a
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Identity Data</span></span
                        ><span lang="EN-GB">
                            includes full name, date of birth gender,
                            nationality and country of residence.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Contact Data</span></span
                        ><span lang="EN-GB">
                            includes billing address, residential address, email
                            address and telephone numbers.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Financial Data</span></span
                        ><span lang="EN-GB">
                            includes bank account and payment card
                            details.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Transaction Data</span></span
                        ><span lang="EN-GB">
                            includes details about payments to and from you and
                            other details of products and services you have
                            purchased from us.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Technical Data</span></span
                        ><span lang="EN-GB">
                            includes internet protocol (IP) address, your login
                            data, browser type and version, time zone setting
                            and location, browser plug-in types and versions,
                            operating system and platform, and other technology
                            on the devices you use to access this website.
                        </span>
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Profile Data</span></span
                        ><b><span lang="EN-GB"> </span></b
                        ><span lang="EN-GB"
                            >includes your username and password, purchases or
                            orders made by you, your interests, preferences,
                            feedback and survey responses. 
                        </span>
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Usage Data</span></span
                        ><span lang="EN-GB">
                            includes information about how you use our website,
                            products and services.
                        </span>
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span class="DefTerm"
                            ><span lang="EN-GB"
                                >Marketing and Communications Data</span
                            ></span
                        ><b><span lang="EN-GB"> </span></b
                        ><span lang="EN-GB"
                            >includes your preferences in receiving marketing
                            from us and our third parties and your communication
                            preferences.</span
                        >
                    </p>

                    <p class="ParaClause" style="margin-left: 0in">
                        <span lang="EN-GB">We also collect, use and share </span
                        ><span class="DefTerm"
                            ><span lang="EN-GB">Aggregated Data</span></span
                        ><span lang="EN-GB">
                            such as statistical or demographic data for any
                            purpose. Aggregated Data could be derived from your
                            personal data but is not considered personal data in
                            law as this data will <b>not</b> directly or
                            indirectly reveal your identity. For example, we may
                            aggregate your Usage Data to calculate the
                            percentage of users accessing a specific website
                            feature. However, if we combine or connect
                            Aggregated Data with your personal data so that it
                            can directly or indirectly identify you, we treat
                            the combined data as personal data which will be
                            used in accordance with this privacy policy.</span
                        >
                    </p>

                    <p class="ParaClause" style="margin-left: 0in">
                        <span lang="EN-GB">We do not collect any </span
                        ><span class="DefTerm"
                            ><span lang="EN-GB"
                                >Special Categories of Personal Data</span
                            ></span
                        ><span lang="EN-GB">
                            about you (this includes details about your race or
                            ethnicity, religious or philosophical beliefs, sex
                            life, sexual orientation, political opinions, trade
                            union membership, information about your health, and
                            genetic and biometric data).
                        </span>
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a331664"
                            ><span lang="EN-GB"
                                >If you fail to provide personal data</span
                            ></a
                        >
                    </p>

                    <p class="ParaClause" style="margin-left: 0in">
                        <span lang="EN-GB"
                            >Where we need to collect personal data by law, or
                            under the terms of a contract we have with you, and
                            you fail to provide that data when requested, we may
                            not be able to perform the contract we have or are
                            trying to enter into with you (for example, to
                            provide you with goods or services), or else will
                            only be able to proceed with reduced functional
                            capability. In this case, we may have to cancel a
                            product or service you have with us but we will
                            notify you if this is the case at the time.
                        </span>
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >3.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a524838"></a
                            ><a name="_Toc256000002"
                                >How is your personal data collected?</a
                            ></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a653340"
                            ><span lang="EN-GB"
                                >We use different methods to collect data from
                                and about you including through:</span
                            ></a
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><b><span lang="EN-GB">Direct interactions</span></b
                        ><b><span lang="EN-GB">.</span></b
                        ><span lang="EN-GB">
                            You may give us your Identity, Contact and Financial
                            Data by filling in forms or by corresponding with us
                            by post, phone, email or otherwise. This includes
                            personal data you provide when you
                        </span>
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >apply for our products or services;</span
                        >
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >create an account on our website;</span
                        >
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >respond to an emailed request from us to provide
                            your details;</span
                        >
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >subscribe to our service or publications;
                        </span>
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >request marketing to be sent to you;</span
                        >
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >enter a competition, promotion or survey; or</span
                        >
                    </p>

                    <p class="ClauseBullet2">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >give us feedback or contact us.
                        </span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><b
                            ><span lang="EN-GB"
                                >Automated technologies or interactions.</span
                            ></b
                        ><span lang="EN-GB">
                            As you interact with our website, we will
                            automatically collect Technical Data about your
                            equipment, browsing actions and patterns. We collect
                            this personal data by using cookies, server logs and
                            other similar technologies. We may also receive
                            Technical Data about you if you visit other websites
                            employing our cookies. Please see our
                            <i>cookie policy</i> for further details.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><b
                            ><span lang="EN-GB"
                                >Third parties or publicly available
                                sources.</span
                            ></b
                        ><span lang="EN-GB">
                            We <b>may</b> receive personal data about you from
                            various third parties and public sources</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >     The third parties and public sources may be as
                            set out below:
                        </span>
                    </p>

                    <p class="NoNumUntitledsubclause1">
                        <a name="a794664"
                            ><span lang="EN-GB"
                                >Technical Data from the following products used
                                or parties:</span
                            ></a
                        >
                    </p>

                    <p class="Untitledsubclause2">
                        <a name="a756109"
                            ><span lang="EN-GB"
                                >(a)<span style="font: 7pt 'Times New Roman'"
                                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span></span
                            ><span lang="EN-GB"
                                >analytics providers such as Google based
                                outside the UK;
                            </span></a
                        >
                    </p>

                    <p
                        class="Untitledsubclause2"
                        style="margin-left: 49.7pt; text-indent: 0in"
                    >
                        <span lang="EN-GB"
                            >The following Open Source licenses apply to our
                            technology stack:</span
                        >
                    </p>

                    <table
                        class="MsoNormalTable"
                        border="0"
                        cellspacing="0"
                        cellpadding="0"
                        width="370"
                        style="
                            width: 277.3pt;
                            margin-left: 105pt;
                            border-collapse: collapse;
                        "
                    >
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://www.apache.org/licenses/LICENSE-2.0.html"
                                                ><span style="color: #0563c1"
                                                    >Apache License, Version
                                                    2.0</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://docs.python.org/3/license.html#psf-license"
                                                ><span style="color: #0563c1"
                                                    >History and License —
                                                    Python 3.9.5
                                                    documentation</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a href="https://mit-license.org/"
                                                ><span style="color: #0563c1"
                                                    >MIT License
                                                    (mit-license.org)</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://www.w3.org/Consortium/Legal/2002/copyright-documents-20021231"
                                                ><span style="color: #0563c1"
                                                    >W3C Document License</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://www.redhat.com/en/about/agreements"
                                                ><span style="color: #0563c1"
                                                    >Red Hat License
                                                    Agreements</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://www.mongodb.com/community/licensing"
                                                ><span style="color: #0563c1"
                                                    >MongoDB Licensing |
                                                    MongoDB</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://redis.io/topics/license"
                                                ><span style="color: #0563c1"
                                                    >Redis license and trademark
                                                    information – Redis</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://en.wikipedia.org/wiki/IBM_Public_License"
                                                ><span style="color: #0563c1"
                                                    >IBM Public License -
                                                    Wikipedia</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://en.wikipedia.org/wiki/Eclipse_Public_License"
                                                ><span style="color: #0563c1"
                                                    >Eclipse Public License -
                                                    Wikipedia</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 14.35pt">
                            <td
                                width="370"
                                nowrap
                                valign="bottom"
                                style="
                                    width: 277.3pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                    height: 14.35pt;
                                "
                            >
                                <p
                                    class="MsoNormal"
                                    style="
                                        margin-bottom: 0in;
                                        line-height: normal;
                                    "
                                >
                                    <u
                                        ><span
                                            lang="EN-GB"
                                            style="color: #0563c1"
                                            ><a
                                                href="https://en.wikipedia.org/wiki/BSD_licenses#2-clause_license_(%22Simplified_BSD_License%22_or_%22FreeBSD_License%22)"
                                                ><span style="color: #0563c1"
                                                    >BSD licenses -
                                                    Wikipedia</span
                                                ></a
                                            ></span
                                        ></u
                                    >
                                </p>
                            </td>
                        </tr>
                    </table>

                    <p class="Untitledsubclause1" style="text-indent: 0in">
                        <span lang="EN-GB">&nbsp;</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Contact, Financial and Transaction Data from
                            providers of technical, payment and delivery
                            services such as Stripe based inside<b> </b>or
                            outside the UK.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Identity and Contact Data from data brokers or
                            aggregators such as Factiva Ltd or Refinitiv Ltd
                            based outside the UK.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Identity and Contact Data from publicly available
                            sources including but not limited to the respective
                            jurisdiction’s relevant authorities’ sanction lists
                            (if available), HM Treasury Financial Sanction list,
                            the United Nations Security Council Consolidated
                            List and the US Treasury Office of Foreign Assets
                            Control (OFAC) Sanctions Lists.</span
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >4.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a179246"></a
                            ><a name="_Toc256000003"
                                >How we use your personal data</a
                            ></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a964261"
                            ><span lang="EN-GB"
                                >We will only use your personal data when the
                                law allows us to. Most commonly, we will use
                                your personal data in the following
                                circumstances:</span
                            ></a
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where we need to perform the contract we are about
                            to enter into or have entered into with you.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where it is necessary for our legitimate interests
                            (or those of a third party) and your interests and
                            fundamental rights do not override those
                            interests.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where we need to comply with a legal
                            obligation.</span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a261444"
                            ><span lang="EN-GB"
                                >See Glossary section below to find out more
                                about the types of lawful basis that we will
                                rely on to process your personal data.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a852894"
                            ><span lang="EN-GB"
                                >Generally, we do not rely on consent as a legal
                                basis for processing your personal data. You
                                have the right to withdraw consent to marketing
                                at any time by contacting us.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a309744"
                            ><span lang="EN-GB"
                                >Purposes for which we will use your personal
                                data</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a218374"
                            ><span lang="EN-GB"
                                >We have set out below, in a table format, a
                                description of all the ways we plan to use your
                                personal data, and which of the legal bases we
                                rely on to do so. We have also identified what
                                our legitimate interests are where
                                appropriate.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a638713"
                            ><span lang="EN-GB"
                                >Note that we <b>may</b> process your personal
                                data for more than one lawful ground depending
                                on the specific purpose for which we are using
                                your data. Please contact us if you need details
                                about the specific legal ground we are relying
                                on to process your personal data where more than
                                one ground has been set out in the table below.
                            </span></a
                        >
                    </p>

                    <table
                        class="MsoNormalTable"
                        border="1"
                        cellspacing="0"
                        cellpadding="0"
                        style="border-collapse: collapse; border: none"
                    >
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <b
                                        ><span
                                            lang="EN-GB"
                                            style="font-size: 11pt"
                                            >Purpose/Activity</span
                                        ></b
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border: solid windowtext 1pt;
                                    border-left: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <b
                                        ><span
                                            lang="EN-GB"
                                            style="font-size: 11pt"
                                            >Type of data</span
                                        ></b
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border: solid windowtext 1pt;
                                    border-left: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <b
                                        ><span
                                            lang="EN-GB"
                                            style="font-size: 11pt"
                                            >Lawful basis for processing
                                            including basis of legitimate
                                            interest</span
                                        ></b
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To register you as a new customer</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >Performance of a contract with
                                        you</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To process and deliver your order
                                        including:</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Manage payments, fees and
                                        charges</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Collect and recover money owed to
                                        us</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Financial
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(d) Transaction
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(e) Marketing and Communications</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Performance of a contract with you
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Necessary for our legitimate
                                        interests (to recover debts due to
                                        us)</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To perform ‘Know your Customer checks
                                        upon you to enable a risk assessment of
                                        you.</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Financial
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(d) Transaction
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Profile
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(d) Usage</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Ability to provide our services to
                                        you
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >&nbsp;</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To manage our relationship with you
                                        which will include:</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Notifying you about changes to our
                                        terms or privacy policy</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Asking you to leave a review or
                                        take a survey</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Profile
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(d) Marketing and Communications</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Performance of a contract with you
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Necessary to comply with a legal
                                        obligation</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Necessary for our legitimate
                                        interests (to keep our records updated
                                        and to study how customers use our
                                        products/services)</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To administer and protect our business
                                        and this website (including
                                        troubleshooting, data analysis, testing,
                                        system maintenance, support, reporting
                                        and hosting of data) 
                                    </span>
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Technical</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Necessary for our legitimate
                                        interests (for running our business,
                                        provision of administration and IT
                                        services, network security, to prevent
                                        fraud and in the context of a business
                                        reorganisation or group restructuring
                                        exercise)</span
                                    >
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Necessary to comply with a legal
                                        obligation</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To deliver relevant website content and
                                        advertisements to you and measure or
                                        understand the effectiveness of the
                                        advertising we serve to you</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Profile
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(d) Usage
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(e) Marketing and Communications
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(f) Technical
                                    </span>
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >Necessary for our legitimate interests
                                        (to study how customers use our
                                        products/services, to develop them, to
                                        grow our business and to inform our
                                        marketing strategy)</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To use data analytics to improve our
                                        website, products/services, marketing,
                                        customer relationships and
                                        experiences</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Technical
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Usage
                                    </span>
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >Necessary for our legitimate interests
                                        (to define types of customers for our
                                        products and services, to keep our
                                        website updated and relevant, to develop
                                        our business and to inform our marketing
                                        strategy)</span
                                    >
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td
                                width="237"
                                valign="top"
                                style="
                                    width: 178pt;
                                    border: solid windowtext 1pt;
                                    border-top: none;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >To make suggestions and recommendations
                                        to you about goods or services that may
                                        be of interest to you</span
                                    >
                                </p>
                            </td>
                            <td
                                width="184"
                                valign="top"
                                style="
                                    width: 137.85pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(a) Identity
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(b) Contact
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >(c) Technical
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="FR" style="font-size: 11pt"
                                        >(d) Usage
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="FR" style="font-size: 11pt"
                                        >(e) Profile
                                    </span>
                                </p>
                                <p class="Paragraph">
                                    <span lang="FR" style="font-size: 11pt"
                                        >(f) Marketing and Communications</span
                                    >
                                </p>
                            </td>
                            <td
                                width="291"
                                valign="top"
                                style="
                                    width: 218.25pt;
                                    border-top: none;
                                    border-left: none;
                                    border-bottom: solid windowtext 1pt;
                                    border-right: solid windowtext 1pt;
                                    padding: 0in 5.4pt 0in 5.4pt;
                                "
                            >
                                <p class="Paragraph">
                                    <span lang="EN-GB" style="font-size: 11pt"
                                        >Necessary for our legitimate interests
                                        (to develop our products/services and
                                        grow our business)</span
                                    >
                                </p>
                            </td>
                        </tr>
                    </table>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a602347"
                            ><span lang="EN-GB">Marketing </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a724870"
                            ><span lang="EN-GB"
                                >We strive to provide you with choices regarding
                                certain personal data uses, particularly around
                                marketing and advertising.
                            </span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a505069"
                            ><span lang="EN-GB"
                                >Promotional offers from us
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a295679"
                            ><span lang="EN-GB"
                                >We may use your Identity, Contact, Technical,
                                Usage and Profile Data to form a view on what we
                                think you may want or need, or what may be of
                                interest to you. This is how we decide which
                                products, services and offers may be relevant
                                for you (we call this marketing).
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a718211"
                            ><span lang="EN-GB"
                                >You will receive marketing communications from
                                us if you have requested information from us or
                                purchased services from us and you have not
                                opted out of receiving that marketing.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a879432"
                            ><span lang="EN-GB">Opting out</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a685745"
                            ><span lang="EN-GB"
                                >You can ask us to stop sending you marketing
                                messages at any time by contacting us at any
                                time.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a697118"
                            ><span lang="EN-GB"
                                >Where you opt out of receiving these marketing
                                messages, this will not apply to personal data
                                provided to us as a result of a service
                                purchase, warranty registration, service
                                experience or other transactions.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a512081"><span lang="EN-GB">Cookies</span></a>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a591491"
                            ><span lang="EN-GB"
                                >You can set your browser to refuse all or some
                                browser cookies, or to alert you when websites
                                set or access cookies. If you disable or refuse
                                cookies, please note that some parts of this
                                website may become inaccessible or not function
                                properly. For more information about the cookies
                                we use, please see our <i>Cookie Policy</i>.
                            </span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a233076"
                            ><span lang="EN-GB">Change of purpose </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a290238"
                            ><span lang="EN-GB"
                                >We will only use your personal data for the
                                purposes for which we collected it, unless we
                                reasonably consider that we need to use it for
                                another reason and that reason is compatible
                                with the original purpose. If you wish to get an
                                explanation as to how the processing for the new
                                purpose is compatible with the original purpose,
                                please contact us.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a178016"
                            ><span lang="EN-GB"
                                >If we need to use your personal data for an
                                unrelated purpose, we will notify you and we
                                will explain the legal basis which allows us to
                                do so.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a834833"
                            ><span lang="EN-GB"
                                >Please note that we may process your personal
                                data without your knowledge or consent, in
                                compliance with the above rules, where this is
                                required or permitted by law.</span
                            ></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >5.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a239061"></a
                            ><a name="_Toc256000004"
                                >Disclosures of your personal data</a
                            ></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a342752"
                            ><span lang="EN-GB"
                                >We may share your personal data with the
                                parties set out below for the purposes set out
                                in the table
                                <i
                                    >Purposes for which we will use your
                                    personal data</i
                                >
                                above.</span
                            ></a
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Internal Third Parties as set out in the
                            <i>Glossar</i>y.
                        </span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >External Third Parties as set out in the
                            <i>Glossary</i>.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Specific third parties listed in the table
                            <i
                                >Purposes for which we will use your personal
                                data</i
                            >
                            above.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Third parties to whom we may choose to sell,
                            transfer or merge parts of our business or our
                            assets. Alternatively, we may seek to acquire other
                            businesses or merge with them. If a change happens
                            to our business, then the new owners may use your
                            personal data in the same way as set out in this
                            privacy policy.
                        </span>
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a880441"
                            ><span lang="EN-GB"
                                >We require all third parties to respect the
                                security of your personal data and to treat it
                                in accordance with the law. We do not allow our
                                third-party service providers to use your
                                personal data for their own purposes and only
                                permit them to process your personal data for
                                specified purposes and in accordance with our
                                instructions.</span
                            ></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >6.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a888527"></a
                            ><a name="_Toc256000005"
                                >International transfers</a
                            ></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a926207"
                            ><span lang="EN-GB"
                                >Many of our external third parties are based in
                                different jurisdictions around the world, so
                                their processing of your personal data will
                                involve a transfer of data outside the UK.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a108510"
                            ><span lang="EN-GB"
                                >Wherever we process your personal data, we
                                ensure a similar degree of protection is
                                afforded to it by ensuring at least one of the
                                following safeguards is implemented:
                            </span></a
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >We will only transfer your personal data to
                            countries that have been deemed to provide an
                            adequate level of protection for personal data.
                        </span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where we use certain service providers, we may use
                            specific contracts approved for use in the UK which
                            give personal data the same protection it has in the
                            UK. <a name="a379822"></a
                        ></span>
                    </p>

                    <p
                        class="ClauseBullet1"
                        style="margin-left: 0.5in; text-indent: 0in"
                    >
                        <span lang="EN-GB"
                            >Please contact us if you want further information
                            on the specific mechanism used by us when processing
                            your data.
                        </span>
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >7.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a424553"></a
                            ><a name="_Toc256000006">Data security</a></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a117271"
                            ><span lang="EN-GB"
                                >We have put in place appropriate security
                                measures to prevent your personal data from
                                being accidentally lost, used or accessed in an
                                unauthorised way, altered or disclosed. In
                                addition, we limit access to your personal data
                                to those employees, agents, contractors and
                                other third parties who have a business need to
                                know. They will only process your personal data
                                on our instructions and they are subject to a
                                duty of confidentiality.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a347220"
                            ><span lang="EN-GB"
                                >We have put in place procedures to deal with
                                any suspected personal data breach and will
                                notify you and any applicable regulator of a
                                breach where we are legally required to do
                                so.</span
                            ></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >8.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a852989"></a
                            ><a name="_Toc256000007">Data retention</a></span
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a536431"
                            ><span lang="EN-GB"
                                >How long will you use my personal data
                                for?</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a656402"
                            ><span lang="EN-GB"
                                >We will only retain your personal data for as
                                long as reasonably necessary to fulfil the
                                purposes we collected it for. Generally we will
                                delete your data upon termination of our
                                services, however data may be retained longer
                                than this to give you time to take or copy or
                                for the purposes of satisfying any legal,
                                regulatory, tax, accounting or reporting
                                requirements. We may retain your personal data
                                for a longer period in the event of a complaint
                                or if we reasonably believe there is a prospect
                                of litigation in respect to our relationship
                                with you.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a679927"
                            ><span lang="EN-GB"
                                >To determine the appropriate retention period
                                for personal data, we consider the amount,
                                nature and sensitivity of the personal data, the
                                potential risk of harm from unauthorised use or
                                disclosure of your personal data, the purposes
                                for which we process your personal data and
                                whether we can achieve those purposes through
                                other means, and the applicable legal,
                                regulatory, tax, accounting or other
                                requirements.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a137296"
                            ><span lang="EN-GB"
                                >In some circumstances you can ask us to delete
                                your data: see <i>your legal rights</i> below
                                for further information.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a938517"
                            ><span lang="EN-GB"
                                >In some circumstances we will anonymise your
                                personal data (so that it can no longer be
                                associated with you) for research or statistical
                                purposes, in which case we may use this
                                information indefinitely without further notice
                                to you.
                            </span></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >9.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a152621"></a
                            ><a name="_Toc256000008">Your legal rights</a></span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a777128"
                            ><span lang="EN-GB"
                                >Under certain circumstances, you have rights
                                under data protection laws in relation to your
                                personal data. Please click on the links below
                                to find out more about these rights:
                            </span></a
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Request access to your personal data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Request correction of your personal data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Request erasure of your personal data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Object to processing of your personal
                                data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Request restriction of processing your personal
                                data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Request transfer of your personal data</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><i
                            ><span lang="EN-GB"
                                >Right to withdraw consent</span
                            ></i
                        ><span lang="EN-GB">.</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="background: yellow"
                            >&nbsp;</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="background: yellow"
                            >&nbsp;</span
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a694615"
                            ><span lang="EN-GB"
                                >If you wish to exercise any of the rights set
                                out above, please contact us.
                            </span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a367507"
                            ><span lang="EN-GB"
                                >No fee usually required</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a152124"
                            ><span lang="EN-GB"
                                >You will not have to pay a fee to access your
                                personal data (or to exercise any of the other
                                rights). However to the extent permissible under
                                law, we reserve the right to charge a nominal
                                fee commensurate with our costs of extraction
                                and collection of information where significant
                                work is involved. We will require you to
                                adequately identify yourself when requesting a
                                copy of your personal information.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <span lang="EN-GB"
                            >We may also charge a reasonable fee if your request
                            is clearly unfounded, repetitive or excessive.
                            Alternatively, we could refuse to comply with your
                            request in these circumstances.</span
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a892914"
                            ><span lang="EN-GB"
                                >What we may need from you</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a853930"
                            ><span lang="EN-GB"
                                >We may need to request specific information
                                from you to help us confirm your identity and
                                ensure your right to access your personal data
                                (or to exercise any of your other rights). This
                                is a security measure to ensure that personal
                                data is not disclosed to any person who has no
                                right to receive it. We may also contact you to
                                ask you for further information in relation to
                                your request to speed up our response.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a703850"
                            ><span lang="EN-GB">Time limit to respond</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a594954"
                            ><span lang="EN-GB"
                                >We try to respond to all legitimate requests
                                within one month. Occasionally it could take us
                                longer than a month if your request is
                                particularly complex or you have made a number
                                of requests. In this case, we will notify you
                                and keep you updated.
                            </span></a
                        >
                    </p>

                    <p class="TitleClause">
                        <span lang="EN-GB"
                            >10.<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            ><a name="a682882"></a
                            ><a name="_Toc256000009">Glossary</a></span
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a165093"
                            ><span lang="EN-GB">LAWFUL BASIS</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a647495"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Legitimate Interest</span
                                ></span
                            ><span lang="EN-GB">
                                means the interest of our business in conducting
                                and managing our business to enable us to give
                                you the best service/product and the best and
                                most secure experience. We make sure we consider
                                and balance any potential impact on you (both
                                positive and negative) and your rights before we
                                process your personal data for our legitimate
                                interests. We do not use your personal data for
                                activities where our interests are overridden by
                                the impact on you (unless we have your consent
                                or are otherwise required or permitted to by
                                law). You can obtain further information about
                                how we assess our legitimate interests against
                                any potential impact on you in respect of
                                specific activities by contacting us.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a865675"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Performance of Contract</span
                                ></span
                            ><span lang="EN-GB">
                                means processing your data where it is necessary
                                for the performance of a contract to which you
                                are a party or to take steps at your request
                                before entering into such a contract.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a865636"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Comply with a legal obligation</span
                                ></span
                            ><span lang="EN-GB">
                                means processing your personal data where it is
                                necessary for compliance with a legal obligation
                                that we are subject to.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a968507"
                            ><span lang="EN-GB">THIRD PARTIES</span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a678226"
                            ><span lang="EN-GB">Internal Third Parties</span></a
                        >
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a548600"
                            ><span lang="EN-GB" style="font-weight: normal"
                                >Other companies in the Idenfo Group who are
                                based primarily in the United Kingdom, United
                                Arab Emirates, Pakistan or Malaysia and provide
                                IT and system administration services, marketing
                                services and leadership reporting.
                            </span></a
                        ><span lang="EN-GB" style="font-weight: normal"
                            >Additional countries may be added in the future.<a
                                name="a995424"
                            >
                            </a></span
                        ><span lang="EN-GB" style="font-weight: normal"
                            >We do this so that we can take advantage of the
                            specialist skills of other members of the Idenfo
                            group in developing our products, processing data
                            and services. The companies we disclose to in these
                            jurisdictions are both subsidiary companies and are
                            members of and bound by safe harbour schemes
                            concerning the use and management of personal
                            information with standard data protection clauses
                            adopted by the Information Commissioner. In
                            circumstances where we disclose personal information
                            we hold to them, we generally retain control of that
                            information for the purposes of those schemes,
                            unless we have obtained your express consent to
                            provide your information to any other recipients.
                            Note therefore that that these subsidiaries will not
                            access or use any data without the consent of Idenfo
                            Limited. We can therefore ensure that the
                            information we disclose is used only in accordance
                            with this policy.
                        </span>
                    </p>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <span lang="EN-GB">External Third Parties</span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Cloud Service providers acting as processors based
                            both inside and outside the UK who provide IT, Cloud
                            and system administration services. Note however
                            that cloud providers will not access or use any data
                            without the consent of Idenfo Limited.
                        </span>
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Professional advisers including lawyers, bankers,
                            auditors and insurers who provide consultancy,
                            banking, legal, insurance and accounting
                            services.</span
                        >
                    </p>

                    <p class="ClauseBullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >International and National regulators and other
                            authorities based who require reporting of
                            processing activities in certain circumstances or
                            are bound by any statutory duty to do so.
                        </span>
                    </p>

                    <b
                        ><span
                            lang="EN-GB"
                            style="
                                font-size: 11pt;
                                font-family: 'Arial', sans-serif;
                                color: black;
                            "
                            ><br
                                clear="all"
                                style="page-break-before: always"
                            /> </span
                    ></b>

                    <p class="NoNumTitle-Clause" style="margin-left: 0in">
                        <a name="a513536"
                            ><span lang="EN-GB">YOUR LEGAL RIGHTS</span></a
                        >
                    </p>

                    <p class="NoNumUntitledClause" style="margin-left: 0in">
                        <a name="a484071"
                            ><span lang="EN-GB">You have the right to:</span></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a100058"
                            ><span class="DefTerm"
                                ><span lang="EN-GB">Request access</span></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >to your personal data (commonly known as a
                                &quot;data subject access request&quot;). This
                                enables you to receive a copy of the personal
                                data we hold about you and to check that we are
                                lawfully processing it.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a297597"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Request correction</span
                                ></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >of the personal data that we hold about you.
                                This enables you to have any incomplete or
                                inaccurate data we hold about you corrected,
                                though we may need to verify the accuracy of the
                                new data you provide to us.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a836012"
                            ><span class="DefTerm"
                                ><span lang="EN-GB">Request erasure</span></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >of your personal data. This enables you to ask
                                us to delete or remove personal data where there
                                is no good reason for us continuing to process
                                it. You also have the right to ask us to delete
                                or remove your personal data where you have
                                successfully exercised your right to object to
                                processing (see below), where we may have
                                processed your information unlawfully or where
                                we are required to erase your personal data to
                                comply with local law. Note, however, that we
                                may not always be able to comply with your
                                request of erasure for specific legal reasons
                                which will be notified to you, if applicable, at
                                the time of your request.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a789450"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Object to processing</span
                                ></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >of your personal data where we are relying on a
                                legitimate interest (or those of a third party)
                                and there is something about your particular
                                situation which makes you want to object to
                                processing on this ground as you feel it impacts
                                on your fundamental rights and freedoms. You
                                also have the right to object where we are
                                processing your personal data for direct
                                marketing purposes. In some cases, we may
                                demonstrate that we have compelling legitimate
                                grounds to process your information which
                                override your rights and freedoms.</span
                            ></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a520072"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Request restriction of processing</span
                                ></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >of your personal data. This enables you to ask
                                us to suspend the processing of your personal
                                data in the following scenarios:
                            </span></a
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >If you want us to establish the data's
                            accuracy.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where our use of the data is unlawful but you do
                            not want us to erase it.</span
                        >
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >Where you need us to hold the data even if we no
                            longer require it as you need it to establish,
                            exercise or defend legal claims.
                        </span>
                    </p>

                    <p class="subclause1Bullet1">
                        <span lang="EN-GB" style="font-family: Symbol"
                            >·<span style="font: 7pt 'Times New Roman'"
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span
                        ><span lang="EN-GB"
                            >You have objected to our use of your data but we
                            need to verify whether we have overriding legitimate
                            grounds to use it.
                        </span>
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a546939"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Request the transfer</span
                                ></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >of your personal data to you or to a third
                                party. We will provide to you, or a third party
                                you have chosen, your personal data in a
                                structured, commonly used, machine-readable
                                format. Note that this right only applies to
                                automated information which you initially
                                provided consent for us to use or where we used
                                the information to perform a contract with you.
                            </span></a
                        >
                    </p>

                    <p class="NoNumUntitledsubclause1" style="margin-left: 0in">
                        <a name="a722140"
                            ><span class="DefTerm"
                                ><span lang="EN-GB"
                                    >Withdraw consent at any time</span
                                ></span
                            ><b><span lang="EN-GB"> </span></b
                            ><span lang="EN-GB"
                                >where we are relying on consent to process your
                                personal data. However, this will not affect the
                                lawfulness of any processing carried out before
                                you withdraw your consent. If you withdraw your
                                consent, we may not be able to provide certain
                                products or services to you. We will advise you
                                if this is the case at the time you withdraw
                                your consent.</span
                            ></a
                        >
                    </p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    methods: {
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
    },
}
</script>
<style scoped>
.wrapper {
    height: 68vh;
    padding: 20px;
    border: 1px solid #000;
    background: #fff;
    display: grid;
    grid-template-rows: 1fr auto;
    overflow-x: hidden;
}
.terms-and-conditions {
    overflow: scroll;
}
/* Font Definitions */
@font-face {
    font-family: Wingdings;
    panose-1: 5 0 0 0 0 0 0 0 0 0;
}
@font-face {
    font-family: 'Cambria Math';
    panose-1: 2 4 5 3 5 4 6 3 2 4;
}
@font-face {
    font-family: Calibri;
    panose-1: 2 15 5 2 2 2 4 3 2 4;
}
@font-face {
    font-family: Verdana;
    panose-1: 2 11 6 4 3 5 4 4 2 4;
}
@font-face {
    font-family: 'Arial Unicode MS';
    panose-1: 2 11 6 4 2 2 2 2 2 4;
}
@font-face {
    font-family: Cambria;
    panose-1: 2 4 5 3 5 4 6 3 2 4;
}
@font-face {
    font-family: Tahoma;
    panose-1: 2 11 6 4 3 5 4 4 2 4;
}
@font-face {
    font-family: '\@Arial Unicode MS';
    panose-1: 2 11 6 4 2 2 2 2 2 4;
}
/* Style Definitions */
p.MsoNormal,
li.MsoNormal,
div.MsoNormal {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 10pt;
    margin-left: 0in;
    line-height: 12pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.MsoToc1,
li.MsoToc1,
div.MsoToc1 {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 5pt;
    margin-left: 0in;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
a:link,
span.MsoHyperlink {
    font-family: 'Arial', sans-serif;
    color: black;
    font-style: italic;
    text-decoration: underline;
}
p.Paragraph,
li.Paragraph,
div.Paragraph {
    mso-style-name: Paragraph;
    mso-style-link: 'Paragraph Char';
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 0in;
    text-align: justify;
    line-height: 15pt;
    font-size: 10pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.TitleClause,
li.TitleClause,
div.TitleClause {
    mso-style-name: 'Title Clause';
    margin-top: 12pt;
    margin-right: 0in;
    margin-bottom: 12pt;
    margin-left: 0.5in;
    text-align: justify;
    text-indent: -0.5in;
    line-height: 15pt;
    page-break-after: avoid;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
    font-weight: bold;
}
span.ParagraphChar {
    mso-style-name: 'Paragraph Char';
    mso-style-link: Paragraph;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.Untitledsubclause1,
li.Untitledsubclause1,
div.Untitledsubclause1 {
    mso-style-name: 'Untitled subclause 1';
    margin-top: 14pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 0.5in;
    text-align: justify;
    text-indent: -0.5in;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.Untitledsubclause2,
li.Untitledsubclause2,
div.Untitledsubclause2 {
    mso-style-name: 'Untitled subclause 2';
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 77.75pt;
    text-align: justify;
    text-indent: -28.05pt;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.Untitledsubclause3,
li.Untitledsubclause3,
div.Untitledsubclause3 {
    mso-style-name: 'Untitled subclause 3';
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 113.75pt;
    text-align: justify;
    text-indent: -0.4in;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.Untitledsubclause4,
li.Untitledsubclause4,
div.Untitledsubclause4 {
    mso-style-name: 'Untitled subclause 4';
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 2in;
    text-align: justify;
    text-indent: -0.5in;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.ParaClause,
li.ParaClause,
div.ParaClause {
    mso-style-name: 'Para Clause';
    margin-top: 6pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 0.5in;
    text-align: justify;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.HeadingLevel2,
li.HeadingLevel2,
div.HeadingLevel2 {
    mso-style-name: 'Heading Level 2';
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 0in;
    text-align: justify;
    line-height: 15pt;
    page-break-after: avoid;
    font-size: 14pt;
    font-family: 'Arial', sans-serif;
    color: black;
    font-weight: bold;
}
p.NoNumTitle-Clause,
li.NoNumTitle-Clause,
div.NoNumTitle-Clause {
    mso-style-name: 'No Num Title - Clause';
    margin-top: 12pt;
    margin-right: 0in;
    margin-bottom: 12pt;
    margin-left: 0.5in;
    text-align: justify;
    line-height: 15pt;
    page-break-after: avoid;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
    font-weight: bold;
}
span.DefTerm {
    mso-style-name: DefTerm;
    font-family: 'Arial', sans-serif;
    color: black;
    font-weight: bold;
}
p.NoNumUntitledClause,
li.NoNumUntitledClause,
div.NoNumUntitledClause {
    mso-style-name: 'No Num Untitled Clause';
    margin-top: 6pt;
    margin-right: 0in;
    margin-bottom: 12pt;
    margin-left: 0.5in;
    text-align: justify;
    line-height: 15pt;
    page-break-after: avoid;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.ClauseBullet1,
li.ClauseBullet1,
div.ClauseBullet1 {
    mso-style-name: 'Clause Bullet 1';
    margin-top: 6pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 53.85pt;
    text-align: justify;
    text-indent: -17.85pt;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.ClauseBullet2,
li.ClauseBullet2,
div.ClauseBullet2 {
    mso-style-name: 'Clause Bullet 2';
    margin-top: 6pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 71.7pt;
    text-align: justify;
    text-indent: -17.85pt;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.subclause1Bullet1,
li.subclause1Bullet1,
div.subclause1Bullet1 {
    mso-style-name: 'subclause 1 Bullet 1';
    margin-top: 12pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 53.85pt;
    text-align: justify;
    text-indent: -17.85pt;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
p.NoNumUntitledsubclause1,
li.NoNumUntitledsubclause1,
div.NoNumUntitledsubclause1 {
    mso-style-name: 'No Num Untitled subclause 1';
    margin-top: 14pt;
    margin-right: 0in;
    margin-bottom: 6pt;
    margin-left: 0.5in;
    text-align: justify;
    line-height: 15pt;
    font-size: 11pt;
    font-family: 'Arial', sans-serif;
    color: black;
}
.MsoChpDefault {
    font-family: 'Calibri', sans-serif;
}
/* Page Definitions */
@page WordSection1 {
    size: 595.3pt 841.9pt;
    margin: 0.5in 0.5in 0.5in 0.5in;
}
div.WordSection1 {
    page: WordSection1;
}
@page WordSection2 {
    size: 595.3pt 841.9pt;
    margin: 0.5in 0.5in 0.5in 0.5in;
}
div.WordSection2 {
    page: WordSection2;
}
/* List Definitions */
ol {
    margin-bottom: 0in;
}
ul {
    margin-bottom: 0in;
}

span {
    color: #000 !important;
}
a {
    color: #000 !important;
}
p {
    margin-bottom: 15px !important ;
}
body a:not([href]):not([tabindex]) {
    color: #000 !important;
    cursor: pointer;
}
</style>
